import { ChevronBottomOutlineIcon, ChevronTopOutlineIcon } from '@ikyucom/design-system-icons-react'
import * as Accordion from '@radix-ui/react-accordion'
import React from 'react'
import { LIST_PRICE_COMPONENTS } from '~/lib/constants/constants'
import type { PlanListPriceItemFragment } from '~/lib/graphql/graphql'
import { money } from '~/lib/money/money'

type Props = {
  listPriceComponents: PlanListPriceItemFragment
}

const PriceBreakdown: React.FC<Props> = ({ listPriceComponents }) => {
  if (!listPriceComponents || !listPriceComponents?.listPriceComponents) {
    return null
  }

  const fieldNameToDisplayName = new Map(Object.entries(LIST_PRICE_COMPONENTS))

  return (
    <div className="_pc:text-base text-xs">
      <Accordion.Root type="single" collapsible>
        <Accordion.Item value="priceBreakdown">
          <Accordion.Trigger className="flex items-center space-x-1 text-blueberry radix-state-open:hidden">
            <div className="text-accent-blue">元値内訳をみる</div>
            <ChevronBottomOutlineIcon />
          </Accordion.Trigger>
          <Accordion.Trigger className="flex items-center space-x-1 text-blueberry radix-state-closed:hidden">
            <div className="text-accent-blue">元値内訳を閉じる</div>
            <ChevronTopOutlineIcon />
          </Accordion.Trigger>
          <Accordion.Content className="overflow-hidden data-[state=closed]:animate-radix-collapsible-close data-[state=open]:animate-radix-collapsible-open">
            <div className="pt-2 text-xs">
              <div className="flex flex-nowrap items-center overflow-y-scroll whitespace-nowrap">
                <div className="flex">
                  {Object.entries(listPriceComponents.listPriceComponents).map(([key, value]) => {
                    if (typeof value === 'number' && value > 0) {
                      const displayName = fieldNameToDisplayName.has(key)
                        ? fieldNameToDisplayName.get(key)
                        : ''
                      return (
                        <p
                          key={key}
                          className="mr-1 flex items-center after:ml-1 after:content-['＋'] last:after:ml-0 last:after:content-['']"
                        >
                          {displayName}
                          <br />
                          {money(value)}円
                        </p>
                      )
                    }
                    return null
                  })}
                </div>
                {Object.values(listPriceComponents.listPriceComponents).filter(
                  (value) => typeof value === 'number' && value > 0
                ).length > 1 &&
                  listPriceComponents.listPrice && (
                    <p className="mr-1 flex items-center before:mr-1 before:content-['='] after:ml-1">
                      合計
                      <br />
                      {money(listPriceComponents.listPrice)}円
                    </p>
                  )}
              </div>
              {listPriceComponents.listPriceIsReference && (
                <p className="text-xs text-neutral-700">
                  ※「元値内訳」は、最も高額なメニューを選択した際の金額で計算されています。
                </p>
              )}
            </div>
          </Accordion.Content>
        </Accordion.Item>
      </Accordion.Root>
    </div>
  )
}

export default PriceBreakdown
